import { CASE_REVIEW_SECTIONS } from "@/features/catalog_case_review/shared/constants/caseReviewSections";
import { agentActionsOf } from "@/features/catalog_case_review/shared/model/fieldActionContext";
import { CODE_MEDDRA_ACTION } from "../constants/pageAgentIds";
import { DOCK_LABELS } from "../constants/pageAgentLabels";

/** Collect exact catalog prompts so ordinary reviewer text is never shortened by a heuristic. */
function meddraPromptsIn(schema: unknown): string[] {
  if (typeof schema !== "object" || schema === null) return [];
  const prompts = agentActionsOf(schema)?.actions
    .filter((action) => action.id === CODE_MEDDRA_ACTION)
    .map((action) => action.prompt.trim()) ?? [];
  return [...prompts, ...Object.values(schema).flatMap(meddraPromptsIn)];
}

const meddraPrompts: ReadonlySet<string> = new Set(
  CASE_REVIEW_SECTIONS.flatMap((section) => meddraPromptsIn(section.fallbackSchema)),
);

/** Presentation only. The agent and stored messages retain the original catalog instructions. */
export function agentPromptDisplay(prompt: string): string {
  return meddraPrompts.has(prompt.trim()) ? DOCK_LABELS.meddraRequest : prompt;
}
